import checkUserLanguage from './components/lang-redirect';
import initReviewSlider from './components/review-slider';

// checkUserLanguage();
initReviewSlider();
